<template>
    <Wrapper>
        <a id="main-content" class="fixed top-0" tabindex="-1"></a>

        <Breadcrumb :items="breadcrumbItems" />

        <div class="grid grid-cols-12 base-responsive-gap mt-6">
            <div class="col-span-12 lg:col-span-7">
                <h1 class="header-1 mb-4">{{ model.title }}</h1>
                <p class="lead"><T t="media_library.lead" /></p>
            </div>
        </div>

        <div class="grid grid-cols-12 card-grid-responsive-gap xl:gap-y-14 mt-12">
            <div
                v-for="gallery in galleries"
                :key="`gallery-${gallery.id}`"
                class="col-span-12 sm:col-span-6 lg:col-span-3"
            >
                <InstitutionGalleryCard
                    :slug="gallery.slug"
                    :category-slug="model.slug"
                    :img="gallery.slides[0]?.src || '/og-image.png'"
                    :photos-count="gallery.slides.length"
                    :title="gallery.title"
                />
            </div>
        </div>
    </Wrapper>
</template>

<script>
import Wrapper from '@/components/Pages/Docs/Wrapper.vue';
import InstitutionGalleryCard from '@/components/Cards/InstitutionGalleryCard/InstitutionGalleryCard.vue';

export default {
    name: 'MediaLibraryIndex',
    components: {
        Wrapper,
        InstitutionGalleryCard,
    },
    async asyncData({ $axios, params, redirect, localePath, i18n }) {
        if (i18n.locale === 'en') {
            return await redirect(307, localePath('magazine'));
        }

        let model = null;
        let galleries = null;

        await $axios
            .$get(`/gallery-categories/by-slug/${params.gallerycategory}`)
            .then((res) => {
                model = res;
            })
            .catch((err) => {
                console.log(err);
            });

        if (!model) {
            return await redirect(307, localePath('press'));
        }

        await $axios
            .$get(`/galleries?category=${model.id}&mediaLibrary=1`)
            .then((res) => {
                galleries = res.data;
            })
            .catch((err) => {
                console.log(err);
            });

        await i18n.generateLocalizedRouteParams(model.locale_variants, 'gallerycategory');

        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('press.title'), 'press']);
        breadcrumbItems.push([i18n.t('media_library.title'), 'media-library', true, true]);
        breadcrumbItems.push([model.title, 'gallerycategory']);

        return {
            model,
            galleries,
            breadcrumbItems,
        };
    },
    head() {
        return {
            title: this.$getPageTitle(this.model.metadata),
            meta: this.$getPageMetaData(this.model.metadata),
        };
    },
};
</script>

<style scoped></style>
